// extracted by mini-css-extract-plugin
module.exports = {"mandatory":"MandatoryText_mandatory__2_1ke","mandatoryContainer":"MandatoryText_mandatoryContainer__2Owev"};